export let fingerPrintSessionId = ""
export let setFingerPrintId = (id) => { fingerPrintSessionId = id }